import React, { useEffect, useState } from "react";
import StyledContentCard from "../../components/styledComponent/styledContentCard";
import { StyledButton } from "../../components/styledComponent/styledElements";
import { IoDownloadOutline } from "react-icons/io5";
import ImportDataModal from "./importDataModal";
import { importStatus } from "../../server/uploadServices";
import { useAppContext } from "../../contexts/appContext";
import { Col, Row } from "antd";
import { DashboardCards } from "../../components/styledComponent/dashboardCards";
import { BiPurchaseTag } from "react-icons/bi";
import { RiBillLine } from "react-icons/ri";
import { TbUsersGroup } from "react-icons/tb";
import { AiOutlineProduct } from "react-icons/ai";
import { listAllProduct } from "../../server/productServices";
import { listAllCustomer } from "../../server/customerServices";
import { listAllOrders } from "../../server/purchaseOrderServices";
import { listAllQuotation } from "../../server/quotationServices";
import CustomTable from "../../components/styledComponent/styledTable";
import { quotationColumn } from "../quotation/quotationPage";
import { Link, useNavigate } from "react-router-dom";

const Dashboard = () => {
  const [showImportModal, setShowImportModal] = useState(false);
  const [isImporting, setIsImporting] = useState(false);
  const [dashData, setDashData] = useState();
  const [quotation, setQuotation] = useState();
  const { user } = useAppContext();
  const navigate = useNavigate();
  const { startLoading, stopLoading } = useAppContext();

  let intervalId = null;
  var userRole = user?.role;
  var importPermission = user?.access?.import;
  const handleOnImportClick = () => {
    setShowImportModal(true);
  };
  const checkImportStatus = () => {
    importStatus().then((res) => {
      setIsImporting(res.currently_importing);
      if (res.currently_importing) {
        if (!intervalId) {
          intervalId = setInterval(checkImportStatus, 15000);
        }
      } else {
        clearInterval(intervalId);
        intervalId = null;
      }
    });
  };
  const getDashboardData = async () => {
    try {
      startLoading()
      const [product, customer, purchaseOrder, quotation] = await Promise.all([
        listAllProduct(),
        listAllCustomer(),
        listAllOrders(),
        listAllQuotation(),
      ]);

      setDashData({
        productCount: product?.data?.length || 0,
        customerCount: customer?.data?.length || 0,
        purchaseOrderCount: purchaseOrder?.data?.length || 0,
        quotationCount: quotation?.data?.length || 0,
      });
      setQuotation(quotation?.data.slice(0, 5));
    } catch (err) {
      console.error("Error fetching dashboard data:", err);
    }finally{
      stopLoading()
    }
  };

  useEffect(() => {
    if (userRole === "Admin" || importPermission?.view) {
      checkImportStatus();
    }
    getDashboardData();
    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, []);
  return (
    <StyledContentCard>
      <Row className="flex justify-end mb-2 gap-2">
        {(userRole === "Admin" || importPermission?.create) && (
          <StyledButton
            icon={<IoDownloadOutline size={20} />}
            onClick={handleOnImportClick}
            loading={isImporting}
          >
            {isImporting ? "Importing" : "Import"}
          </StyledButton>
        )}
        {showImportModal && (
          <ImportDataModal
            showModal={showImportModal}
            setShowModal={setShowImportModal}
            setImporting={setIsImporting}
          />
        )}
      </Row>
      <Row gutter={24} className="justify-between p-6">
        <DashboardCards
          icon={<AiOutlineProduct size={24} />}
          text={"Products"}
          count={dashData?.productCount}
          redirect={"/product"}
        />
        <DashboardCards
          text={"Sales Orders"}
          icon={<BiPurchaseTag size={24} />}
          count={dashData?.purchaseOrderCount}
          redirect={"/sales-order"}
        />
        <DashboardCards
          text={"Quotations"}
          icon={<RiBillLine size={24} />}
          count={dashData?.quotationCount}
          redirect={"/quotation"}
        />
        <DashboardCards
          text={"Customers"}
          icon={<TbUsersGroup size={24} />}
          count={dashData?.customerCount}
          redirect={"/customer"}
        />
      </Row>
      <Row className=" mt-4">
        <Col lg={12} md={24} sm={24}>
          <p className="details-value">Latest Quotation</p>
          <CustomTable
            data={quotation}
            columns={quotationColumn}
            rowKey="id"
            onRow={(record) => {
              return {
                onClick: () => {
                  navigate(`/quotation/${record.quotation.id}`);
                },
                className: "clickable",
              };
            }}
          />
          {dashData?.quotationCount > 5 && (
            <Link to={"/quotation"} className="links float-right mt-2">
              View More Quotation...
            </Link>
          )}
        </Col>
      </Row>
    </StyledContentCard>
  );
};

export default Dashboard;
